import React, { useState } from 'react';
import { HYWorld } from '../HYWorld/HYWorld';

export function HYAdventureLauncher() {
  const [notice, setNotice] = useState(false);
  return <>
    <button type="button" className="hy-adventure-launcher game-hud" title="ผจญภัย HY" aria-label="ผจญภัย HY" onClick={() => setNotice(true)}>
      <img src={`${process.env.PUBLIC_URL}/hy/icon_bombbi.png`} alt="" />
    </button>
    {notice && <HYWorld onClose={() => setNotice(false)} />}
  </>;
}
